import * as React from 'react'

import {Route} from 'react-router-dom'
import Consent from '$src/consent/components/Consent'
import {authWrapper} from '$util'

import {selectIdToken, selectRefreshToken} from '$src/auth/selectors'

const ConsentWithAuth = authWrapper({
  authSelector: (state) => {
    return selectIdToken(state) && selectRefreshToken(state)
  },
  onNoAuth: props =>
    props.history.replace('/login' + props.history.location.search),
})(Consent)

export default [
  <Route key="consent1" path="/consent" component={ConsentWithAuth} />,
]



// WEBPACK FOOTER //
// ./src/consent/routes.js